import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { body14Styles } from "@constants/typography"
import { DesktopOnly, MobileAndTabletOnly } from "@utils/MediaQuery"
import React from "react"
import styled from "styled-components"

export const Container = styled.div`
  padding: 0 20px 88px;

  @media ${breakpoints.tablet} {
    padding: 0 calc(1 / 12 * 100vw) 88px;
  }

  @media ${breakpoints.laptop} {
    padding: 0 calc(1 / 12 * 100vw) 178px;
  }
`

export const GifWrapper = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - 40px);
  flex-grow: 0;
  flex-shrink: 0;

  @media ${breakpoints.tablet} {
    width: calc(10 / 12 * 100vw);
    height: calc(10 / 12 * 100vw);
  }

  @media ${breakpoints.laptop} {
    width: calc(10 / 12 * 100vw);
    height: calc(10 / 12 * 100vw * 0.51);
  }
`

const GifContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

const GifPadding = styled.div`
  width: 100%;
  padding-bottom: 100%;
`

const Gif = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
`

const CaptionWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  align-items: center;
`

const Caption = styled.div`
  width: calc(100% - 35px);
  font-family: "Avenir Roman";
  font-size: 15px;
  color: ${colors.black};
  line-height: 22px;
  opacity: 0.3;

  @media ${breakpoints.tablet} {
    ${body14Styles}
    color: ${colors.mediumGray};
    opacity: 1;
  }

  @media ${breakpoints.laptop} {
    ${body14Styles}
    color: ${colors.mediumGray};
    opacity: 1;
  }
`

const Dash = styled.div`
  width: 23px;
  height: 1px;
  margin-right: 12px;
  background-color: ${colors.mediumGray};
`

interface MediaGifProps {
  blockId?: string
  caption?: string
  gif: string
  mobileGif?: string
}

const MediaGif: React.FC<MediaGifProps> = ({
  blockId,
  caption,
  gif,
  mobileGif,
}) => {
  const renderGif = (src) => (
    <GifWrapper>
      <GifContainer>
        <GifPadding />
        <Gif src={src} />
      </GifContainer>
    </GifWrapper>
  )

  return gif ? (
    <Container id={blockId || undefined}>
      <MobileAndTabletOnly>
        {renderGif(mobileGif ? mobileGif : gif)}
      </MobileAndTabletOnly>
      <DesktopOnly>{renderGif(gif)}</DesktopOnly>
      {caption && (
        <CaptionWrapper>
          <Dash />
          <Caption>{caption}</Caption>
        </CaptionWrapper>
      )}
    </Container>
  ) : null
}

export default MediaGif
